// common/services/completePrivateToDo  (UPDATE)
import { isLoaded, isLoading } from "../actions";
import Alert from "../../../Common/Alert";
import API from "../../../Common/Network/API";

export async function completePrivateToDo(state, dispatch, getUser, pt_id, handleClose, SUBTASK_COMPLETE) {
  dispatch(isLoading());
    try {
      var response = await API.post("private_todo.php", {
        action: "complete",
        pt_id: pt_id,
      }, {}, false);
      if (response.status === 'True') {
        Alert("success", SUBTASK_COMPLETE);
      }
    } catch (error) {
      Alert('error', error.message);
      dispatch(isLoaded());
    }
    handleClose()
} 